
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 291.319 291.319"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M145.659 0c80.45 0 145.66 65.219 145.66 145.66 0 80.45-65.21 145.659-145.66 145.659S0 226.109 0 145.66C0 65.219 65.21 0 145.659 0z","fill":"#c8232c"}}),_c('path',{attrs:{"d":"M150.066 63.781c-51.327 0-77.19 35.632-77.19 65.337 0 17.989 7.028 33.993 22.122 39.956 2.467.974 4.698.036 5.408-2.613l2.203-8.403c.728-2.613.446-3.541-1.548-5.826-4.361-4.962-7.128-11.398-7.128-20.511 0-26.428 20.42-50.089 53.175-50.089 29.014 0 44.945 17.161 44.945 40.075 0 30.152-13.783 55.606-34.248 55.606-11.289 0-19.755-9.04-17.042-20.156 3.241-13.237 9.541-27.539 9.541-37.107 0-8.548-4.743-15.704-14.575-15.704-11.553 0-20.829 11.571-20.829 27.074 0 9.878 3.45 16.551 3.45 16.551l-13.901 56.998c-4.124 16.906-.61 37.644-.319 39.738.182 1.238 1.821 1.529 2.567.601 1.065-1.347 14.821-17.798 19.5-34.239 1.329-4.652 7.602-28.75 7.602-28.75 3.751 6.946 14.721 13.046 26.383 13.046 34.712 0 58.273-30.652 58.273-71.674-.011-31.015-27.14-59.91-68.389-59.91z","fill":"#fff"}})])
          )
        }
      }
    